import { useMutation } from '@tanstack/react-query';

import { UpdateMyAccountData } from '../../../../../types';
import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postUpdateMyAccount } from '../../requests/postUpdateMyAccount';

export const useUpdateMyAccount = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: updateMyAccount, ...rest } = useMutation({
    mutationFn: (data: UpdateMyAccountData) =>
      postUpdateMyAccount(constructPost, data).then(
        (response) => response?.data,
      ),
    onError: () => handleError('Failed to update account'),
  });

  return { updateMyAccount, ...rest };
};
